import cx from 'classnames';
import orderSummaryStyles from '../OrderSummary.scss';
import styles from './HardwarePayment.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { CheckoutRoutePath } from 'src/components/Checkout/Checkout';
import { HardwarePaymentPlans } from 'src/components/OrderSummary/HardwarePaymentPlans/HardwarePaymentPlans';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { redesignV2RoutePath } from 'src/constants/redesignV2';
import { ProductList } from '../ProductList/ProductList';
import { SubtotalTitle } from '../SubtotalTitle/SubtotalTitle';
import { TaxSection } from '../TaxSection/TaxSection';

interface HardwarePaymentProps {
  isCheckout?: boolean;
}

export const HardwarePayment: React.FC<HardwarePaymentProps> = ({ isCheckout }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isReviewPath = location.pathname === (redesignV2RoutePath.PURCHASE + CheckoutRoutePath.REVIEW);

  return (
    <section className={orderSummaryStyles.section}>
      <SubtotalTitle isCheckout={isCheckout} />
      {isCheckout ? <ProductList /> : <HardwarePaymentPlans />}
      <div className={cx(styles.container, { [styles.containerBordered] : !isReviewPath })}>
        <TextV2
          variant="body"
          tagName="p"
          value={t('order-summary.shipping')}
          className={styles.containerLabel}
          data-test="shipping-label"
        />
        <TextV2
          variant="body"
          tagName="p"
          value={t('order-summary.free')}
          data-test="shipping-value"
        />
      </div>
      {isReviewPath && <TaxSection />}
    </section>
  );
};

HardwarePayment.displayName = 'HardwarePayment';
